import { render } from "./waitlist-mobile.vue?vue&type=template&id=1a81f9d1&scoped=true"
import script from "./waitlist-mobile.vue?vue&type=script&lang=js"
export * from "./waitlist-mobile.vue?vue&type=script&lang=js"

import "./waitlist-mobile.vue?vue&type=style&index=0&id=1a81f9d1&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a81f9d1"]])

export default __exports__